import React from "react";
import { AppBar } from "@material-ui/core";
import { useSelector } from "react-redux";
import BarSesion from "./BarSesion";
import BarSesionDefault from "./BarDefault";
import { useLocation } from "react-router-dom";
const AppNavbar = () => {
  //const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
 
  const getColorBar = () => {
    if(process.env.REACT_APP_COLOR_BAR === 'test'){
      if(process.env.REACT_APP_ENVIRONMENT === 'production')  //UAT
        return { backgroundColor: 'red' }
      else if(process.env.REACT_APP_ENVIRONMENT === 'test')   //OnexaTest
        return { backgroundColor: 'blue' }
    }else if(process.env.REACT_APP_COLOR_BAR === 'development'){
      return { backgroundColor: 'blue' }
    }
    return {}
  }
  
  return auth ? (
    !!auth.idUsuario && location.pathname !== '/totem' && location.pathname !== '/totemMoron' ? (
      <AppBar 
        position="static" 
        style={getColorBar()}
      >
        {location.pathname === "/" ? <BarSesionDefault /> : <BarSesion />} 
       
      </AppBar>
    ) : null
  ) : null;
};

export default AppNavbar;
